export default __webpack_public_path__ + "/dist/images/no_data_icon.91626d03142e3480e632e5638dcadfa3.svg";